import { SVGProps, Ref, forwardRef } from 'react';

export const DocumentVerifiedOutlinedSize16Glyph = forwardRef(
    (props: SVGProps<SVGSVGElement>, ref: Ref<SVGSVGElement>) => (
        <svg
            width={16}
            height={16}
            viewBox="0 0 16 16"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            ref={ref}
            {...props}
        >
            <g>
                <path d="m10.997 5.009.99.99-4.989 4.988-2.99-2.989.99-.99 2 2z" fill="currentColor" />
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M14 15.5V5.955C14 1.864 12.667.5 8.667.5H2v15zm-1.4-1.4V5.955c0-1.974-.34-2.846-.768-3.283-.418-.428-1.249-.772-3.165-.772H3.4v12.2z"
                    fill="currentColor"
                />
            </g>
        </svg>
    )
);
DocumentVerifiedOutlinedSize16Glyph.displayName = 'DocumentVerifiedOutlinedSize16Glyph';
